export default __webpack_public_path__ + "static/media/logo_01.baf60b06.png";